export type ChatMessageElement = HTMLDivElement
export const ChatMessageFrom = ['me', 'other'] as const
export type ChatMessageFrom = (typeof ChatMessageFrom)[number]
export const ChatMessageSizes = ['md', 'lg'] as const
export type ChatMessageSize = (typeof ChatMessageSizes)[number]
